module.exports = __webpack_public_path__ + "static/media/image22.0d34b18a.png";